module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-lines-3-dbfee99d9a2bbeefa41b998cbaeb8358.svg";